(function () {
  'use strict';

  /*
   * Free Gift Auto-Sync — 3 independent gift slots
   *
   * THEME CART  : listens for "cart-update" custom event fired by theme.js
   * REBUY CART  : uses MutationObserver on Rebuy's cart container — fires
   *               sync only after Rebuy's DOM settles (800 ms debounce).
   *               Never uses rebuy:cart.change to avoid re-add loops.
   *
   * USER REMOVAL GUARD:
   *   - Theme cart  : click on [data-cart-remove] sets userRemoved flag
   *   - Rebuy cart  : we compare cart state BEFORE the mutation (snapshot
   *                   taken right when observer fires) vs AFTER (the actual
   *                   /cart.js fetch inside syncAllGifts). If the gift was
   *                   present in the pre-mutation snapshot but is missing
   *                   now, the user deleted it → set userRemoved, skip add.
   *
   * RESET:
   *   userRemoved clears when qualifying items are removed entirely (qty→0)
   *   OR when a brand-new qualifying variant appears in the cart.
   */

  /* ── State ──────────────────────────────────────────────────────────── */

  var _syncTimer  = null;
  var _busy       = false;
  var _pending    = false;

  var _tagCache        = {};
  var _tagFetchPending = {};

  /* Per-slot state */
  var SLOTS = [1, 2, 3].map(function (n) {
    return {
      id: n,
      storageKey: 'freeGiftUserRemoved_' + n,
      lastQualifyingIds: [],
      lastQualifyingQty: 0
    };
  });

  function getSlot(n) { return SLOTS[n - 1]; }

  function getUserRemoved(slot) {
    try { return sessionStorage.getItem(slot.storageKey) === 'true'; } catch (e) { return false; }
  }
  function setUserRemoved(slot, val) {
    try { sessionStorage.setItem(slot.storageKey, val ? 'true' : 'false'); } catch (e) {}
  }

  /* ── Rebuy detection ────────────────────────────────────────────────── */

  function isRebuyActive() {
    return !!(document.querySelector('.rebuy-cart') || document.querySelector('[data-rebuy-id]'));
  }

  /* ── Pre-mutation cart snapshot (Rebuy only) ────────────────────────── */
  /*
   * _preSnapshot is captured the moment the MutationObserver fires —
   * i.e. BEFORE we fetch /cart.js. This lets us see what was in the cart
   * BEFORE the user's action, so we can detect a deliberate gift removal.
   */
  var _preSnapshot = {}; /* key: giftVariantId → true/false (was gift present) */

  function capturePreSnapshot() {
    /* We use the last known cart state stored in _lastKnownCart */
    var snap = {};
    (_lastKnownCart.items || []).forEach(function (item) {
      if (isFreeGiftItem(item)) {
        snap[item.variant_id] = true;
      }
    });
    _preSnapshot = snap;
  }

  var _lastKnownCart = { items: [] };

  function updateLastKnownCart(cart) {
    _lastKnownCart = cart;
  }

  /* ── Config ─────────────────────────────────────────────────────────── */

  function getConfig(n) {
    var el = document.getElementById('free-gift-data-' + n);
    if (!el) return null;
    var giftVariantId = parseInt(el.dataset.giftVariant, 10);
    if (isNaN(giftVariantId)) return null;
    var tag    = (el.dataset.qualifyingTag || '').trim().toLowerCase();
    var handle = (el.dataset.giftHandle   || '').trim();
    if (!tag) return null;
    return { slotNum: n, giftVariantId: giftVariantId, qualifyingTag: tag, giftHandle: handle };
  }

  /* ── UI ─────────────────────────────────────────────────────────────── */

  function showOffer(n) {
    var el = document.getElementById('free-gift-offer-' + n);
    if (el) el.style.display = '';
    var p = document.getElementById('free-gift-progress-text-' + n);
    if (p) p.style.display = 'none';
  }
  function hideOffer(n) {
    var el = document.getElementById('free-gift-offer-' + n);
    if (el) el.style.display = 'none';
    var p = document.getElementById('free-gift-progress-text-' + n);
    if (p) p.style.display = 'none';
  }
  function showProgress(n) {
    var el = document.getElementById('free-gift-offer-' + n);
    if (el) el.style.display = 'none';
    var p = document.getElementById('free-gift-progress-text-' + n);
    if (p) p.style.display = '';
  }

  function evaluateOffer(n) {
    var slot = getSlot(n);
    if (getUserRemoved(slot)) { hideOffer(n); return; }

    /* Theme cart: items are annotated with data attributes */
    var domItems = document.querySelectorAll('[data-qualifies-for-gift-' + n + '="true"]');
    if (domItems.length > 0) { showOffer(n); return; }

    /* Rebuy cart: no data attrs — use last known cart state */
    var cfg = getConfig(n);
    if (!cfg) return;

    var offerEl = document.getElementById('free-gift-offer-' + n);
    /* If already visible, keep it visible until sync decides otherwise */
    if (offerEl && offerEl.style.display !== 'none') return;

    var tag = cfg.qualifyingTag;
    var giftProductId = _tagCache['v:' + cfg.giftVariantId] || null;
    var hasQualifier = false;
    (_lastKnownCart.items || []).forEach(function (item) {
      if (isFreeGiftItem(item)) return;
      if (giftProductId && String(item.product_id) === giftProductId) return;
      var cachedTags = _tagCache[String(item.product_id)];
      if (cachedTags && cachedTags.indexOf(tag) !== -1) { hasQualifier = true; }
    });
    if (hasQualifier) { showOffer(n); } else { showProgress(n); }
  }

  function evaluateAll() { evaluateOffer(1); evaluateOffer(2); evaluateOffer(3); }

  /* ── Gift item helpers ──────────────────────────────────────────────── */

  function isFreeGiftItem(item) {
    if (!item.properties) return false;
    var v = item.properties['_is_free_gift'];
    return v === 'true' || v === true;
  }
  function giftSlotOf(item) {
    return item.properties ? String(item.properties['_gift_slot'] || '') : '';
  }

  /* ── Tag fetching ───────────────────────────────────────────────────── */

  function getProductTags(handle, productId, callback) {
    var key = String(productId);
    if (_tagCache[key]) { callback(_tagCache[key]); return; }
    if (_tagFetchPending[key]) { _tagFetchPending[key].push(callback); return; }
    _tagFetchPending[key] = [callback];
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return t.trim().toLowerCase(); });
        _tagCache[key] = tags;
        (p.variants || []).forEach(function (v) { _tagCache['v:' + v.id] = key; });
        var cbs = _tagFetchPending[key] || []; delete _tagFetchPending[key];
        cbs.forEach(function (cb) { cb(tags); });
      })
      .catch(function () {
        _tagCache[key] = [];
        var cbs = _tagFetchPending[key] || []; delete _tagFetchPending[key];
        cbs.forEach(function (cb) { cb([]); });
      });
  }

  function resolveGiftProductId(giftVariantId, cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftVariantId) return String(cart.items[i].product_id);
    }
    return _tagCache['v:' + giftVariantId] || null;
  }

  function buildTagMap(cart, giftProductIds, callback) {
    var mainItems = cart.items.filter(function (item) { return !isFreeGiftItem(item); });
    if (!mainItems.length) { callback({}); return; }
    var seen = {}, products = [];
    mainItems.forEach(function (item) {
      var key = String(item.product_id);
      if (!seen[key]) { seen[key] = true; products.push({ id: key, handle: item.handle }); }
    });
    var tagMap = {}, remaining = products.length;
    products.forEach(function (p) {
      getProductTags(p.handle, p.id, function (tags) {
        tagMap[p.id] = tags;
        if (--remaining === 0) callback(tagMap);
      });
    });
  }

  /* ── Drawer refresh (theme cart only) ──────────────────────────────── */

  function refreshDrawer(onDone) {
    /* Rebuy manages its own UI — never touch it from here */
    if (isRebuyActive()) {
      setTimeout(evaluateAll, 150);
      if (typeof onDone === 'function') onDone();
      return;
    }

    var _skipNextCount_ref = ++window.__fgo_skip;

    var done = false;
    function finish() {
      if (done) return; done = true;
      setTimeout(evaluateAll, 150);
      if (typeof onDone === 'function') onDone();
    }
    var safety = setTimeout(finish, 5000);

    function onCartUpdate() {
      clearTimeout(safety);
      document.removeEventListener('cart-update', onCartUpdate);
      finish();
    }
    document.addEventListener('cart-update', onCartUpdate);

    if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { window.halo.updateSidebarCart(cart); })
        .catch(function () {
          window.__fgo_skip = Math.max(0, window.__fgo_skip - 1);
          clearTimeout(safety);
          document.removeEventListener('cart-update', onCartUpdate);
          finish();
        });
      return;
    }

    var root = (window.routes && window.routes.root) || '';
    var $w = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!$w.length) {
      window.__fgo_skip = Math.max(0, window.__fgo_skip - 1);
      clearTimeout(safety);
      document.removeEventListener('cart-update', onCartUpdate);
      finish();
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $w.addClass('is-loading');
        $.ajax({
          type: 'GET', url: root + '/cart?view=ajax_side_cart', cache: false,
          success: function (data) { $w.removeClass('is-loading').html($(data)); },
          complete: function () {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            window.__fgo_skip = Math.max(0, window.__fgo_skip - 1);
            clearTimeout(safety);
            document.removeEventListener('cart-update', onCartUpdate);
            finish();
          }
        });
      })
      .catch(function () {
        window.__fgo_skip = Math.max(0, window.__fgo_skip - 1);
        clearTimeout(safety);
        document.removeEventListener('cart-update', onCartUpdate);
        finish();
      });
  }

  window.__fgo_skip = 0;

  /* ── Cart API ───────────────────────────────────────────────────────── */

  function cartAdd(variantId, qty, slotLabel, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId, quantity: qty,
        properties: { _is_free_gift: 'true', _gift_slot: String(slotLabel) }
      })
    }).then(function () { callback(true); }).catch(function (e) {
      console.error('[free-gift] add error', e); callback(false);
    });
  }
  function cartUpdate(lineKey, qty, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function () { callback(true); }).catch(function (e) {
      console.error('[free-gift] update error', e); callback(false);
    });
  }
  function cartRemove(lineKey, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function () { callback(true); }).catch(function (e) {
      console.error('[free-gift] remove error', e); callback(false);
    });
  }

  /* ── Busy management ────────────────────────────────────────────────── */

  function releaseBusy() {
    _busy = false;
    setTimeout(evaluateAll, 50);
    if (_pending) { _pending = false; syncAllGifts(); }
  }

  /* ── Core sync ──────────────────────────────────────────────────────── */

  function syncAllGifts() {
    if (_busy) { _pending = true; return; }
    _busy = true;
    _pending = false;

    var configs = [1, 2, 3].map(getConfig).filter(Boolean);
    if (!configs.length) { releaseBusy(); return; }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateLastKnownCart(cart);

        resolveGiftProductIds(configs, cart, function (giftProductIds) {
          buildTagMap(cart, giftProductIds, function (tagMap) {

            var groups = {};
            configs.forEach(function (cfg) {
              var k = String(cfg.giftVariantId);
              if (!groups[k]) groups[k] = [];
              groups[k].push(cfg);
            });

            var decisions = Object.keys(groups).map(function (k) {
              return buildGroupDecision(groups[k], cart, tagMap);
            });

            executeDecisionsParallel(decisions);
          });
        });
      })
      .catch(function (e) {
        console.error('[free-gift] cart fetch error', e);
        releaseBusy();
      });
  }

  function resolveGiftProductIds(configs, cart, callback) {
    var ids = [];
    configs.forEach(function (cfg) {
      var pid = resolveGiftProductId(cfg.giftVariantId, cart);
      if (pid && ids.indexOf(pid) === -1) ids.push(pid);
    });
    var unresolved = configs.filter(function (cfg) {
      return !resolveGiftProductId(cfg.giftVariantId, cart) && cfg.giftHandle;
    });
    if (!unresolved.length) { callback(ids); return; }
    var remaining = unresolved.length;
    unresolved.forEach(function (cfg) {
      fetch('/products/' + cfg.giftHandle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var pid = String(p.id);
          _tagCache[pid] = (p.tags || []).map(function (t) { return t.trim().toLowerCase(); });
          (p.variants || []).forEach(function (v) { _tagCache['v:' + v.id] = pid; });
          if (ids.indexOf(pid) === -1) ids.push(pid);
        })
        .catch(function () {})
        .then(function () { if (--remaining === 0) callback(ids); });
    });
  }

  function buildGroupDecision(group, cart, tagMap) {
    var giftVariantId = group[0].giftVariantId;
    var slotLabel = group.length === 1 ? String(group[0].slotNum) : 'combined';
    var totalTargetQty = 0;

    group.forEach(function (cfg) {
      var n = cfg.slotNum, slot = getSlot(n);
      var slotQty = 0, qualifyingIds = [];
      var thisGiftProductId = resolveGiftProductId(cfg.giftVariantId, cart);

      cart.items.forEach(function (item) {
        if (isFreeGiftItem(item)) return;
        if (thisGiftProductId && String(item.product_id) === thisGiftProductId) return;
        var tags = tagMap[String(item.product_id)] || [];
        if (tags.indexOf(cfg.qualifyingTag) !== -1) {
          slotQty += item.quantity;
          if (qualifyingIds.indexOf(item.variant_id) === -1) qualifyingIds.push(item.variant_id);
        }
      });

      var userRemoved = getUserRemoved(slot);
      if (userRemoved) {
        if (slotQty === 0) {
          /* All qualifying items removed — reset flag so next add works */
          setUserRemoved(slot, false); userRemoved = false;
          slot.lastQualifyingIds = []; slot.lastQualifyingQty = 0;
        } else {
          /* Clear flag only if user added a NEW qualifying variant or increased qty */
          var hasNew = qualifyingIds.some(function (id) {
            return slot.lastQualifyingIds.indexOf(id) === -1;
          });
          var qtyUp = slotQty > slot.lastQualifyingQty;
          if (hasNew || qtyUp) { setUserRemoved(slot, false); userRemoved = false; }
        }
      }
      slot.lastQualifyingIds = qualifyingIds.slice();
      slot.lastQualifyingQty = slotQty;

      if (!userRemoved) totalTargetQty += slotQty;
    });

    /* Find existing gift line */
    var giftItem = null;
    cart.items.forEach(function (item) {
      if (item.variant_id === giftVariantId && isFreeGiftItem(item)) giftItem = item;
    });

    var currentQty = giftItem ? giftItem.quantity : 0;
    var action = 'none';
    if      (totalTargetQty === 0 && giftItem)                                 action = 'remove';
    else if (totalTargetQty > 0  && !giftItem)                                 action = 'add';
    else if (totalTargetQty > 0  && giftItem && currentQty !== totalTargetQty) action = 'update';

    /*
     * Rebuy user-removal guard:
     * action='add' means gift is NOT in current cart but qualifying item IS.
     * Check _preSnapshot (captured BEFORE this sync's /cart.js fetch):
     *   - gift WAS in preSnapshot → user just deleted it → suppress add
     *   - gift was NOT in preSnapshot → genuine first add → allow
     */
    if (action === 'add' && isRebuyActive() && _preSnapshot[giftVariantId] === true) {
      group.forEach(function (cfg) {
        setUserRemoved(getSlot(cfg.slotNum), true);
        hideOffer(cfg.slotNum);
      });
      action = 'none';
    }

    return { slotLabel: slotLabel, cfg: group[0], giftItem: giftItem, targetQty: totalTargetQty, action: action };
  }

  function executeDecisionsParallel(decisions) {
    var actionsNeeded = decisions.filter(function (d) { return d.action !== 'none'; });
    if (!actionsNeeded.length) { releaseBusy(); return; }

    var remaining = actionsNeeded.length;
    var anyChanged = false;

    function onOne(changed) {
      if (changed) anyChanged = true;
      if (--remaining === 0) {
        if (anyChanged) { refreshDrawer(function () { releaseBusy(); }); }
        else { releaseBusy(); }
      }
    }

    actionsNeeded.forEach(function (d) {
      if      (d.action === 'add')    cartAdd(d.cfg.giftVariantId, d.targetQty, d.slotLabel, onOne);
      else if (d.action === 'update') cartUpdate(d.giftItem.key, d.targetQty, onOne);
      else if (d.action === 'remove') cartRemove(d.giftItem.key, onOne);
    });
  }

  /* ── Debounce ───────────────────────────────────────────────────────── */

  function scheduleSyncGift(delay) {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function () { _syncTimer = null; syncAllGifts(); }, delay == null ? 500 : delay);
  }

  /* ── Theme cart: manual gift removal via remove button ──────────────── */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    var lineKey = btn.getAttribute('data-line') || null;
    if (!lineKey) return;
    [1, 2, 3].forEach(function (n) {
      var row = document.querySelector('[data-line-key="' + lineKey + '"][data-is-free-gift-' + n + '="true"]');
      if (row) { setUserRemoved(getSlot(n), true); hideOffer(n); }
    });
  }, true);

  /* ── Init ───────────────────────────────────────────────────────────── */

  function init() {

    /* Initialise _lastKnownCart from current cart */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateLastKnownCart(cart); evaluateAll(); })
      .catch(function () {});

    /* Purge dismissed gifts on page load if still in session */
    [1, 2, 3].forEach(function (n) {
      var slot = getSlot(n), cfg = getConfig(n);
      if (!cfg || !getUserRemoved(slot)) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.items.forEach(function (item) {
            if (item.variant_id === cfg.giftVariantId && isFreeGiftItem(item)) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              }).then(function () { refreshDrawer(function () {}); });
            }
          });
        });
    });

    /* Theme cart trigger */
    document.addEventListener('cart-update', function () {
      setTimeout(evaluateAll, 100);
      if (window.__fgo_skip > 0) { window.__fgo_skip--; return; }
      scheduleSyncGift(500);
    });

    /* ── Rebuy Smart Cart ─────────────────────────────────────────────── */

    var _rebuyObserver   = null;
    var _rebuySettleTimer = null;

    function moveOffersIntoRebuyCart() {
      var rebuyCart =
        document.querySelector('.rebuy-cart__content') ||
        document.querySelector('[data-rebuy-id] .rebuy-cart') ||
        document.querySelector('.rebuy-cart');
      if (!rebuyCart) return;
      if (rebuyCart.querySelector('#free-gift-offer-1, #free-gift-offer-2, #free-gift-offer-3')) return;

      /* Pause observer so inserting our elements doesn't trigger a sync */
      if (_rebuyObserver) _rebuyObserver.disconnect();

      [1, 2, 3].forEach(function (n) {
        var dataEl  = document.getElementById('free-gift-data-' + n);
        var offerEl = document.getElementById('free-gift-offer-' + n);
        if (dataEl)  rebuyCart.insertBefore(dataEl,  rebuyCart.firstChild);
        if (offerEl) rebuyCart.insertBefore(offerEl, rebuyCart.firstChild);
      });

      /* Resume */
      if (_rebuyObserver) {
        _rebuyObserver.observe(rebuyCart, {
          childList: true, subtree: true, attributes: false, characterData: false
        });
      }
    }

    function attachRebuyObserver() {
      var rebuyCart =
        document.querySelector('.rebuy-cart__content') ||
        document.querySelector('.rebuy-cart');
      if (!rebuyCart) return false;

      moveOffersIntoRebuyCart();
      evaluateAll();

      if (_rebuyObserver) return true;

      _rebuyObserver = new MutationObserver(function () {
        if (_busy) return; /* our own writes — ignore */

        /*
         * Capture pre-mutation state RIGHT NOW (before debounce delay).
         * _lastKnownCart reflects the last /cart.js we fetched — this is
         * the "before" state for user-removal detection.
         */
        capturePreSnapshot();

        clearTimeout(_rebuySettleTimer);
        _rebuySettleTimer = setTimeout(function () {
          if (!_busy) scheduleSyncGift(0);
        }, 800);
      });

      _rebuyObserver.observe(rebuyCart, {
        childList: true, subtree: true, attributes: false, characterData: false
      });

      return true;
    }

    document.addEventListener('rebuy:cart.ready', function () {
      setTimeout(function () { attachRebuyObserver(); evaluateAll(); }, 300);
    });

    var _pollTimer = setInterval(function () {
      if (attachRebuyObserver()) clearInterval(_pollTimer);
    }, 500);
    setTimeout(function () { clearInterval(_pollTimer); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
